(function(angular, schoolwork12) {
    'use strict';
    
    schoolwork12.app.studentview = {
        name: 'schoolwork12.studentview',
        controllers: {
            studentGradPlanView: 'studentGradPlanViewCntrl',
            studentBySubjectView: 'studentBySubjectViewCntrl'
        },
        routes: {           
            studentViewGradPlan: '/student-graduation-plan-view'
        },
        templates: {          
            studentViewGradPlan: 'studentView_gradPlan/html/studentGradPlanView.html',           
        }
    };
    angular.module(schoolwork12.app.studentview.name, ['ngAnimate','ui.bootstrap']);
    
}(angular, schoolwork12));